import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'cross-join-nudges.request-access-success-flag.title',
		defaultMessage: 'A request was sent to your admins',
		description: 'Title of invite success flag after user has requested to join Confluence',
	},
	description: {
		id: 'cross-join-nudges.request-access-success-flag.description',
		defaultMessage: "You'll receive an email once they've reviewed it.",
		description: 'Description informing the user their request has been successfully sent',
	},
});
